import React from 'react';
export function Intro() {
  return <section className="px-4 py-6 md:py-8" data-id="element-49">
      <div className="max-w-2xl mx-auto" data-id="element-50">
        <p className="text-lg text-gray-800 leading-relaxed mb-4" data-id="element-51">
          For decades, men over 40 have been told that declining energy, focus,
          and vitality are just "part of aging." But a revolutionary new
          supplement is changing everything we thought we knew about men's
          health after 40.
        </p>
        <p className="text-lg text-gray-800 leading-relaxed" data-id="element-52">
          These Alpha Gummies are flying off the shelves for a reason - they're
          helping thousands of men reclaim the energy, strength, and confidence
          they thought was gone forever. Here's why men everywhere are making
          the switch...
        </p>
      </div>
    </section>;
}